<div class="conatiner-div d-flex flex-column">
    <div class="topHead d-flex justify-content-between">
        <span>Filter</span>
        <div class="close-button" (click)="onCloseClick()">
            <mat-icon class="close-icon">close</mat-icon>
        </div>
    </div>
    <div class="d-flex flex-column gap-3">
        <div class="state-filter">
            <span class="search-text mb-2">Start Date</span>
            <input type="date" name="startDate" id="date" class="dp-input-control search-input" [formControl]="startDate">
           
        </div>
        <div class="state-filter">
            <span class="search-text mb-2">End Date</span>
             <input type="date" name="endDate" id="date" class="dp-input-control search-input" [formControl]="endDate">
           
        </div>
        <!-- <div class="d-flex flex-column">
            <span class="search-text mb-2">Family Code</span>
            <input type="tel" maxlength="12" class="dp-input-control search-input"
                placeholder="Enter 12 digit family code" [formControl]="familyCode">
        </div> -->
    </div>
    <div class="d-flex btn-main-div">
        <button class="dp-secondary-btn btn-div" (click)="onClearClick()">
            Clear all
        </button>

        <button class="dp-primary-btn btn-div" (click)="onSearchClick()">
            Search
        </button>
    </div>
</div>
<!-- <app-loader [isLoading]="isLoading"></app-loader> -->
